import React, { useState } from 'react';
import fallbackImage from '../../assets/images/join_our_team.webp';

const JobCard = ({ id, title, location, description, image, fullTime = true, onApplyClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  
  
  return (
    <>
      <div 
        className={`w-full max-w-[1280px] flex flex-col md:flex-row bg-white rounded-[24px] border border-gray-200 overflow-hidden mb-6 transition-all duration-300 ${isHovered ? 'shadow-lg transform -translate-y-1' : 'shadow-sm'}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Image - top on mobile, right on desktop */}
        <div className="w-full md:w-[526px] h-[250px] md:h-[363px] md:ml-auto md:order-2 overflow-hidden relative">
          {/* Loading state */}
          {imageLoading && (
            <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-[15.95px] flex items-center justify-center">
              <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
            </div>
          )}
          
          <img 
            src={imageError ? fallbackImage : (image || fallbackImage)} 
            alt={title} 
            className={`w-full h-full object-cover rounded-[15.95px] transition-transform duration-500 ${isHovered ? 'scale-105' : 'scale-100'} ${imageLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => {
              setImageLoading(false);
              setImageError(false);
            }}
            onError={(e) => {
              setImageError(true);
              setImageLoading(false);
              e.target.onerror = null;
              e.target.src = fallbackImage;
            }}
          />
        </div>
        
        {/* Content - bottom on mobile, left on desktop */}
        <div className="w-full md:w-[614px] pt-[28px] p-[12px] md:p-[35px] flex flex-col gap-4 md:gap-[30px] md:order-1">
          <div>
            <h3 className="font-inter font-medium text-2xl md:text-[29.52px] leading-[150%] tracking-[-3%] capitalize mb-[12px]">
              #{title}
            </h3>
            <p className="font-inter font-normal text-base md:text-[18px] leading-[150%] text-gray-700 opacity-50">
              Location: {location} | {fullTime ? 'Full-time' : 'Part-time'}
            </p>
          </div>
          
          <p className="font-inter font-normal text-base md:text-[18px] leading-[150%] text-gray-600 opacity-50">
            {description}
          </p>
          
          <div>
            <button 
              onClick={() => onApplyClick({ title, description })}
              className={`bg-black text-white font-inter font-medium px-[21.26px] py-2 rounded-[21.26px] min-w-[111.64px] max-w-[637.93px] h-[44px] transition-all duration-300 mt-4 md:mt-[0] flex items-center gap-2 ${isHovered ? 'bg-gray-800 transform scale-105' : 'bg-black'}`}
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </>
    );
};

export default JobCard;
